import { render, staticRenderFns } from "./unionNotices.vue?vue&type=template&id=7bd9e414&"
import script from "./unionNotices.vue?vue&type=script&lang=js&"
export * from "./unionNotices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "unionNotices.vue"
export default component.exports